import React from 'react'
import Paper from '../UI/Paper/Paper'
import Row from '../Grids/Row/Row'
import Column from '../Grids/Column/Column'
import Icons from '../UI/Icons'
import Button from '../UI/Forms/Button/Button'
import i18n from '~/i18n'
import PermissionChecker from '~/Classes/permissions'
import { useSelector } from 'react-redux'

export default function LandingPagesEmptyState({ addLandingPage }) {
    const permissionStore = useSelector((state) => state.permission)

    const features = [
        {
            icon: 'goal',
            title: i18n.t('form:landingPages.emptyState.features.focused-goal')
        },
        {
            icon: 'lineChart',
            title: i18n.t('form:landingPages.emptyState.features.clear-conversion-metrics')
        },
        {
            icon: 'lightningOutline',
            title: i18n.t('form:landingPages.emptyState.features.live-in-minutes')
        }
    ]

    const ways = [
        {
            icon: 'pointerClick',
            title: i18n.t('form:landingPages.emptyState.ways.items.demo-signup-pages.title'),
            description: i18n.t('form:landingPages.emptyState.ways.items.demo-signup-pages.description')
        },
        {
            icon: 'calendarCheck',
            title: i18n.t('form:landingPages.emptyState.ways.items.event-webinar-registration.title'),
            description: i18n.t('form:landingPages.emptyState.ways.items.event-webinar-registration.description')
        },
        {
            icon: 'documentDownload',
            title: i18n.t('form:landingPages.emptyState.ways.items.gated-lead-magnets.title'),
            description: i18n.t('form:landingPages.emptyState.ways.items.gated-lead-magnets.description')
        },
        {
            icon: 'megaphoneOutline',
            title: i18n.t('form:landingPages.emptyState.ways.items.targeted-campaign-pages.title'),
            description: i18n.t('form:landingPages.emptyState.ways.items.targeted-campaign-pages.description')
        }
    ]

    return (
        <>
            <Paper className='paper-purple-light' style={{ padding: '48px 48px 48px 64px' }}>
                <Row>
                    <Column
                        xs={12}
                        sm={6}
                        md={8}
                        style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}
                    >
                        <p className='mar-b15 landing-pages-empty-state__get-started'>
                            {i18n.t('form:landingPages.emptyState.get-started')}
                        </p>
                        <h2 className='mar-b15 landing-pages-empty-state__header'>
                            {i18n.t('form:landingPages.emptyState.title')}
                        </h2>
                        <p className='landing-pages-empty-state__description'>
                            {i18n.t('form:landingPages.emptyState.description')}
                        </p>

                        {PermissionChecker('campaigns', permissionStore.permissions, 'write') && (
                            <div className='mar-t25'>
                                <Button
                                    className='button-primary'
                                    onClick={addLandingPage}
                                    text={i18n.t('form:landingPages.addLandingPage')}
                                    iconLeft={<Icons icon='plus' />}
                                    postHogTag='landing-page-highlight-create'
                                />
                            </div>
                        )}

                        <div className='landing-pages-empty-state__features'>
                            {features.map((feature) => (
                                <div className='landing-pages-empty-state__feature'>
                                    <Icons icon={feature.icon} />
                                    <p className='landing-pages-empty-state__feature-title'>{feature.title}</p>
                                </div>
                            ))}
                        </div>
                    </Column>
                    <Column xs={12} sm={6} md={4}>
                        <img
                            src='https://cdn1.ourmailsender.com/siteContent/noneholdersnew/landingpages-none.png'
                            style={{ width: '100%' }}
                        />
                    </Column>
                </Row>
            </Paper>
            <p className='mar-t25 mar-b25 landing-pages-empty-state__get-started'>
                {i18n.t('form:landingPages.emptyState.ways.tagline')}
            </p>
            <Row>
                {ways.map((way) => (
                    <Column
                        xs={6}
                        sm={4}
                        md={3}
                        style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}
                    >
                        <Paper>
                            <Icons icon={way.icon} className='landing-pages-empty-state__way-icon' />
                            <h5 className='landing-pages-empty-state__way-title'>{way.title}</h5>
                            <p className='landing-pages-empty-state__way-description'>{way.description}</p>
                        </Paper>
                    </Column>
                ))}
            </Row>
        </>
    )
}
